import { units } from '@ui/css';
import { makeSizeTokens } from '@utils/react';

const transitionDurationMs = 225;
const taskHeaderSize = makeSizeTokens("--task-header", {
  height: units.px(71),
  width: "100%"
});
const header = "_35shsgvr2n";
const progress = "_35sp572v5b";
const headingWrapper = "_35sh1fjj61s";
const heading = "_35shty7di9";
const tools = "_35st79vgre";
const finishButton = "_35sf1ogy46j";

export { finishButton, header, heading, headingWrapper, progress, taskHeaderSize, tools, transitionDurationMs };
import "./_task-header.style.linaria.module.css";
//# sourceMappingURL=_task-header.style.js.map
